export const CONTENT_ALIGNMENT = ['left', 'center', 'right'];
